<template>
    <div>
        <div class="ep-form-toolbar">
            <div class="col-md-9 ep-tools-title">
                <a class="ep-help-toggle ep-tools">
                    <div data-placement="middle">
                        <i class="fa fa-question"></i>
                        <span>  {{header_status.help_message}}</span>
                    </div>
                </a>
            </div>
            <div class="col-md-3">
                <a  v-bind:class="['btn', 'btn-primary', 'btn-labeled', 'fa', panel_opened?'fa-chevron-down':'fa-chevron-right', 'pull-right']" role="button" @click="dashEvent({'topic':'open-panel', 'task_name': status_values.TASK_SELECT})">
                {{panel_opened?'CHIUDI PANNELLO':'APRI PANNELLO'}}</a>
            </div>
        </div>
        <div class="content-panel" v-if="api && config">
            <div v-show="panel_opened">
                <DashPanelHeader v-on:dash-event="dashEvent($event)" v-bind:task="task" :header_status="header_status" :dash_panel_opened="dash_panel_opened" :header_filters_active="header_filters_active"/>
                <TaskSelect v-on:dash-event="dashEvent($event)" ref="taskSelect" v-if="task.status===status_values.TASK_SELECT"/>
                <Report :api="api" :config="config" v-bind:task="task" v-if="task.status===status_values.TASK_REPORT" v-on:dash-event="dashEvent($event)" :header_status="header_status" :footer_status="footer_status" ref="report"/>
                <CardCreate :api="api" :config="config" v-bind:task="task" v-if="task.status===status_values.CARD_CREATE" v-on:dash-event="dashEvent($event)" :header_status="header_status"  ref="cardCreate" :graphs="graphs_"/>
                <CardSearch :api="api" :config="config" v-bind:task="task" v-if="task.status===status_values.CARD_SEARCH" v-on:dash-event="dashEvent($event)" :header_status="header_status" :footer_status="footer_status"  ref="cardSearch" :graphs="graphs_"/>
                <DashPanelFooter v-on:dash-event="dashEvent($event)" v-bind:task="task" v-if="task.status!==status_values.NO_TASK" :footer_status="footer_status" :footer_items_active="footer_items_active"/>
            </div>
            <div style="padding: 0 20px 60px; margin-top: -1px; overflow-y:auto; min-heigth:400px; width: 100%;">
                <div class="report-image-grid" style="margin-top: 5px;">
                    <ReportPanel :api="api" :config="config" v-if="user_is_reviewer" style="flex: 1; padding-right: 5px;"/>
                    <HeritagePanel :api="api" :config="config" style="flex: 1; padding-right: 5px;"/>
                    <EditsLogsPanel :api="api" :config="config" style="flex: 1; padding-right: 5px;"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { dashboard_config, status_values, dash_tasks} from '../utils/env';
import Report  from './Report';
import ReportPanel from './ReportPanel';
import DashPanelHeader from './panels/DashPanelHeader';
import TaskSelect from './TaskSelect';
import DashPanelFooter from './panels/DashPanelFooter';
import HeritagePanel from './HeritagePanel';
import EditsLogsPanel from './EditsLogsPanel';
import CardCreate from './CardCreate';
import CardSearch from './CardSearch';
import ApiProvider from './ApiProvider.js';

export default {
    name: 'ArchesActionDash',
    components: {
        Report,
        ReportPanel,
        DashPanelHeader,
        TaskSelect,
        DashPanelFooter,
        HeritagePanel,
        EditsLogsPanel,
        CardCreate,
        CardSearch
    },
    data: function () {
        return {
            task: dash_tasks[status_values.NO_TASK],
            status_values: status_values,
            dash_tasks: dash_tasks,
            header_status: {combo_filter_values: null, help_message: null, text_filter: null, root_combo_filter: "", leaf_combo_filter: ""},
            footer_status: {'paginator': null, 'page_selected': 1},
            header_filters_active: {'text': false, 'combo': false, 'multiple_combo':false},
            dash_panel_opened: false,
            currentComponent: null,
            panel_opened: false,
            graphs_: window.graphs_,
            user_is_reviewer: null,
            api: null,
            config: null,
            
        }
    },
    methods: {
        changeTask(task_name) {
            this.task = this.dash_tasks[task_name];
            this.header_status.help_message = this.task.help_message;
            this.currentComponent = this.task.ref;
        },
        setTask(task) {
            this.task = task;
            this.header_status.help_message = this.task.help_message;
            this.currentComponent = this.task.ref;
        },
        openPanel: function() {
            this.panel_opened = this.panel_opened?false:true;
        },
        updatePanel: function() {
            this.header_status.combo_filter_values = [];
            this.header_status.root_combo_filter = "";
            this.header_status.leaf_combo_filter = "";
            this.header_status.text_filter = "";
            this.workflowUpdates();
        },
        workflowUpdates: function() {
            this.header_status.help_message = 'workflow' in this.task?this.task.workflow[this.task.workflow_current_index].help_message:this.task.help_message;
            this.header_filters_active = 'workflow' in this.task?this.task.workflow[this.task.workflow_current_index].header_filters_active:this.task.header_filters_active;
            this.footer_items_active = 'workflow' in this.task?this.task.workflow[this.task.workflow_current_index].footer_items_active:this.task.footer_items_active;
        },
        dashEvent(event) {
            switch(event.topic) {
                case 'open-panel':
                    this.updatePanel();
                    this.openPanel();
                    this.changeTask(this.status_values.TASK_SELECT);
                    this.header_status.help_message = this.task.help_message;
                    break;
                case 'search-filter-update':
                    this.currentComponent.searchFilterUpdate(event.filters);
                    break;
                case 'task-selected':
                    switch('task' in event)  {
                        case false:
                            this.changeTask(event.task_name);
                            break;
                        case true:
                            this.setTask(event.task);
                            break;
                    }
                    this.updatePanel();
                    break;
                case 'header-status':
                    this.header_status = event.header_status;
                    break;
                case 'workflow-current-index':
                    this.task.workflow_current_index = event.workflow_current_index;
                    this.workflowUpdates();
                    break;
            }

        }
    },
    computed: {
    },
    watch: {
        'task': function() {
            
        },
        'header_status': {
            handler() {
                console.log(this.header_status);
            },
            deep: true
        }
    },
    beforeMount: function() {
        let config = window.dashboard_config_?window.dashboard_config_:dashboard_config;
        this.api = new ApiProvider(config);
        this.config = config;
        this.user_is_reviewer = window.user_is_reviewer;
    },
}
</script>

<style scoped>
    #app .task-child {
        min-width: 220px;
        overflow-y: auto;
    }

    .panel-heading {
        height: 50px;
        margin-top: 0px!important;
        padding: 2px 2px 2px 2px;
        background-color: #FFFFFF;
        border-width: 0px 0px 0px 0px;
        border-style: solid;
        border-color: #FFFFFF;
    }

    .panel-footer {
        border-width: 0px 0px 0px 0px;
        border-color: #000000;
        border-style: solid;
    }

    .panel-body {
       border: 1px solid;
       border-color: #9e5757;
    }

    button.btn {
        margin: 10px;
        float: left;
    }

    .panel-heading button {
        float: left;
        margin: 4px;
    }

    .panel-heading>a {
        border-width: 0px 0px 0px 1px;
        border-color: #FFFFFF;
        border-style: solid;
    }

    .panel-heading>div {
        border-width: 0px 0px 0px 0px;
        border-color: #FFFFFF;
        border-style: solid;
    }

    .panel-heading>div>a {
        height: 30px;
        padding: 4px 6px;
    }
    .panel-heading button.btn {
        top: 4px;
        padding: 4px 4px 4px 4px;
    }

    .form-control {
        max-width: 160px;
        margin-left: 4px;
    }

    div.well {
        padding: 4px 4px 4px 4px;
        max-height: 50px;
        width: 600px;
        margin: 2px 2px 2px 2px;
        vertical-align: middle;
        font-size: 16px;
    }

    div.well > * {
        max-height: 36px;
        margin: 4px 4px 4px 4px;
        font-size: 16px;
    }

    div.well > span {
        font-size: 18px;
        margin-top: 20px;
    }

    div[class^="col-"] {
        padding: 2px 2px 2px 2px;

    }

    #app > div > div.ep-form-toolbar > a {
        max-width: 180px!important;
        margin-right: 15px;
    }

    .workflow-child {
        padding-left: 60px;
        overflow-y: auto;
    }

    div.content-panel div .report-image-grid {
        text-align: center;
    }
    div.content-panel div .report-image-grid * {
        display: inline-block;
    }

    .content-panel {
        height: unset;
    }

    .report-image-grid {
        display: flex;
        flex-flow: wrap;
    }

    .card-grid-item * {
        min-width: 400px;
        width: 100%;

    }

    .card-grid-item {
        min-width: 400px;
        width: 100%;
        cursor: default;

    }

    @media only screen and (max-device-width: 480px) {
    
        .card-grid-item * {

            min-width: 320px;

            }

        .card-grid-item {

            min-width: 320px;

            }
        
        .report-image-grid {
            flex-direction: column;
        }

        #app > div > div.content-panel > div > div.ep-form-toolbar {
            flex-wrap: wrap; 
            text-align: center;
            padding-left: unset; 
            padding-right: unset;
        }
       #app > div > div.content-panel > div:nth-child(1) > div.ep-form-toolbar > div {
            margin-left: auto!important;
            margin-right: auto!important;
        }
    }

</style>

